import React from "react";
import { AlertTriangle } from "lucide-react";

const SUBSEA_TEXT =
  "Subsea well-control calculations require rig-specific subsea stack data, marine riser data, choke/kill line geometry, control system details, approved company procedures, and qualified well-control review. This tool provides calculation support only and is not a live well-control instruction system.";

const WELL_CONTROL_TEXT =
  "This calculator is for calculation support, training, and qualified review only. It is not a live well-control instruction system. Final well-control decisions must be made by certified personnel using approved company procedures, rig-specific data, well-control manuals, and regulatory requirements.";

const GENERAL_TEXT =
  "Verify all inputs, units, formulas, and results before operational use. RigSentinel does not replace engineering judgment, company procedures, certified personnel, or regulatory requirements.";

// Three flavours:
//   <SafetyBanner />               → general yellow safety notice
//   <SafetyBanner wellControl />   → red well-control notice (used on Well Control calc pages)
//   <SafetyBanner subsea />        → red subsea-stack notice (used on subsea calc pages)
export function SafetyBanner({ wellControl = false, subsea = false, compact = false }) {
  const isRed = wellControl || subsea;
  const testid = subsea
    ? "safety-subsea-stack"
    : wellControl
      ? "safety-well-control"
      : "safety-general";
  const text = subsea ? SUBSEA_TEXT : wellControl ? WELL_CONTROL_TEXT : GENERAL_TEXT;
  return (
    <div
      data-testid={testid}
      className={`flex gap-2 ${compact ? "p-2.5" : "p-3"} rounded-md border`}
      style={{
        background: isRed ? "rgba(244,67,54,0.08)" : "rgba(255,193,7,0.07)",
        borderColor: isRed ? "#C62828" : "#F57F17",
      }}
    >
      <AlertTriangle
        className="w-4 h-4 mt-0.5 shrink-0"
        style={{ color: isRed ? "var(--rs-danger)" : "var(--rs-warning)" }}
      />
      <p className={`text-xs leading-snug ${isRed ? "text-[#FCA5A5]" : "text-[#FBD38D]"}`}>{text}</p>
    </div>
  );
}
